import { BadgeProps } from '@evrekadev/evreka-ui-components'
import { Badge, Flex, Typography } from 'components'
import React from 'react'
import { UilArrowGrowth, UilChartDown } from '@iconscout/react-unicons'
import { TypographySkeleton } from 'components/Skeletons/TypographySkeleton'

export type DeltaBadgeVariant = 'success' | 'warning' | 'danger' | 'stable'
export type DeltaBadgeTrend = 'up' | 'down' | 'stable'

export type DeltaBadgeProps = {
  variant: DeltaBadgeVariant
  trend: DeltaBadgeTrend
  value: string
  text?: string
}

export const DeltaBadge: React.FC<DeltaBadgeProps> = ({ value, variant, trend, text }) => {
  return (
    <Flex gap={0.25} middle="zero" style={{ flexShrink: 0 }}>
      <Badge
        size="medium"
        display="flex"
        color={getVariantColor(variant)}
        iconLeft={getTrendIcon(trend)}
      >
        {value}
      </Badge>
      {text && (
        <Typography fontSize="text_xs" fontWeight="medium" color="grey500">
          {text}
        </Typography>
      )}
    </Flex>
  )
}

export const DeltaBadgeSkeleton: React.FC = () => (
  <Flex gap={0.25} middle="zero" style={{ flexShrink: 0 }}>
    <TypographySkeleton height="text_xs" words={2} separate />
  </Flex>
)

const getVariantColor = (variant: DeltaBadgeVariant): BadgeProps['color'] => {
  switch (variant) {
    case 'success':
      return 'green'
    case 'warning':
      return 'orange'
    case 'danger':
      return 'red'
    case 'stable':
      return 'grey'
  }
}

const getTrendIcon = (variant: DeltaBadgeTrend) => {
  switch (variant) {
    case 'up':
      return UilArrowGrowth
    case 'down':
      return UilChartDown
    case 'stable':
      return undefined
  }
}
